import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
export default history;

export const getQueryParams = (search) => {
  return new URLSearchParams(search);
};
